import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "comm-prefs d-flex flex-column p-2 p-lg-0" }
const _hoisted_2 = { class: "title-2 text-primary-black mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-grey-700"
}
const _hoisted_4 = { class: "prefs-body" }
const _hoisted_5 = { class: "prefs-section" }
const _hoisted_6 = { class: "prefs-section__title" }
const _hoisted_7 = { class: "prefs-section__intro" }
const _hoisted_8 = { class: "prefs-row" }
const _hoisted_9 = { class: "prefs-row__text" }
const _hoisted_10 = { class: "prefs-row__label" }
const _hoisted_11 = { class: "prefs-row__desc" }
const _hoisted_12 = { class: "prefs-row" }
const _hoisted_13 = { class: "prefs-row__text" }
const _hoisted_14 = { class: "prefs-row__label" }
const _hoisted_15 = { class: "prefs-row__desc" }
const _hoisted_16 = { class: "prefs-section" }
const _hoisted_17 = { class: "prefs-section__title" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "prefs-row prefs-row--start" }
const _hoisted_20 = { class: "prefs-row__text" }
const _hoisted_21 = { class: "prefs-row__label" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "prefs-section" }
const _hoisted_24 = { class: "prefs-section__title" }
const _hoisted_25 = { class: "prefs-section__intro" }
const _hoisted_26 = { class: "prefs-row prefs-row--start" }
const _hoisted_27 = { class: "prefs-row__text" }
const _hoisted_28 = { class: "prefs-row__label" }
const _hoisted_29 = { class: "prefs-row__desc" }
const _hoisted_30 = { class: "comm-prefs__footer" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { class: "comm-prefs__save-wrap" }

import { computed, onMounted, reactive, ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  import ToggleSwitch from '@/components/common/ToggleSwitch/v1/ToggleSwitch.vue'
  import Button from '@/components/UI/Button.vue'
  import loggedInUser from '@/state/loggedInUser'
  import isSubscribeNewsletter from '@/state/isSubscribeNewsletter'
  import {
    loadCdaConsentFromCrm,
    saveCdaConsent,
  } from '@/logic/contact/cdaConsent'
  import { CdaConsent, defaultCdaConsent } from '@/types/CdaConsent'
  import { useStore } from '@/store'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CommunicationPreferencesForm',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

  const emit = __emit

  const { t } = useI18n()
  const store = useStore()
  const loading = ref(true)
  const saving = ref(false)
  const draft = reactive<CdaConsent>(defaultCdaConsent())
  /** Snapshot when panel opened — used to detect email turned off (clear IL). */
  const loadedEmail = ref(false)

  const userEmail = computed(
    () => store.state.auth?.user?.email || loggedInUser.value?.email
  )

  const syncDraftFromConsent = () => {
    Object.assign(draft, { ...isSubscribeNewsletter.value, whatsapp: false })
    loadedEmail.value = !!isSubscribeNewsletter.value.email
  }

  const toggleEmail = () => {
    const enabled = !draft.email
    draft.email = enabled
    draft.trackingOpen = enabled
  }

  const handleSave = async () => {
    if (saving.value) return
    saving.value = true
    try {
      const next: CdaConsent = { ...draft, whatsapp: false }
      const clearLegitimateInterest = loadedEmail.value && !next.email
      await saveCdaConsent(
        userEmail.value,
        next,
        clearLegitimateInterest ? { clearLegitimateInterest: true } : undefined
      )
      loadedEmail.value = next.email
      emit('close')
    } finally {
      saving.value = false
    }
  }

  const handleBack = () => {
    syncDraftFromConsent()
    emit('close')
  }

  onMounted(async () => {
    loading.value = true
    try {
      if (userEmail.value) {
        await loadCdaConsentFromCrm(userEmail.value)
      }
      syncDraftFromConsent()
    } finally {
      loading.value = false
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('profile.communicationPreferences.title')), 1),
    (loading.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(t)('profile.communicationPreferences.loading')), 1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("section", _hoisted_5, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(t)('profile.communicationPreferences.sectionDealsTitle')), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)('profile.communicationPreferences.sectionDealsIntro')), 1),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)('profile.communicationPreferences.switchEmail')), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('profile.communicationPreferences.switchEmailDesc')), 1)
                ]),
                _createVNode(ToggleSwitch, {
                  active: draft.email,
                  label: _unref(t)('profile.communicationPreferences.switchEmail'),
                  onToggle: toggleEmail
                }, null, 8, ["active", "label"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)('profile.communicationPreferences.switchSms')), 1),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('profile.communicationPreferences.switchSmsDesc')), 1)
                ]),
                _createVNode(ToggleSwitch, {
                  active: draft.sms,
                  label: _unref(t)('profile.communicationPreferences.switchSms'),
                  onToggle: _cache[0] || (_cache[0] = ($event: any) => (draft.sms = !draft.sms))
                }, null, 8, ["active", "label"])
              ])
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "prefs-separator" }, null, -1)),
            _createElementVNode("section", _hoisted_16, [
              _createElementVNode("h3", _hoisted_17, _toDisplayString(_unref(t)('profile.communicationPreferences.sectionPartnersTitle')), 1),
              _createElementVNode("p", {
                class: "prefs-section__intro",
                innerHTML: _unref(t)('profile.communicationPreferences.sectionPartnersIntro')
              }, null, 8, _hoisted_18),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)('profile.communicationPreferences.switchPartenaires')), 1),
                  _createElementVNode("span", {
                    class: "prefs-row__desc",
                    innerHTML: _unref(t)('profile.communicationPreferences.switchPartenairesDesc')
                  }, null, 8, _hoisted_22)
                ]),
                _createVNode(ToggleSwitch, {
                  active: draft.partenaires,
                  label: _unref(t)('profile.communicationPreferences.switchPartenaires'),
                  onToggle: _cache[1] || (_cache[1] = ($event: any) => (draft.partenaires = !draft.partenaires))
                }, null, 8, ["active", "label"])
              ])
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "prefs-separator" }, null, -1)),
            _createElementVNode("section", _hoisted_23, [
              _createElementVNode("h3", _hoisted_24, _toDisplayString(_unref(t)('profile.communicationPreferences.sectionTrackingTitle')), 1),
              _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(t)('profile.communicationPreferences.sectionTrackingIntro')), 1),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(t)('profile.communicationPreferences.switchTracking')), 1),
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)('profile.communicationPreferences.switchTrackingDesc')), 1)
                ]),
                _createVNode(ToggleSwitch, {
                  active: draft.trackingOpen,
                  label: _unref(t)('profile.communicationPreferences.switchTracking'),
                  onToggle: _cache[2] || (_cache[2] = ($event: any) => (draft.trackingOpen = !draft.trackingOpen))
                }, null, 8, ["active", "label"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("button", {
              type: "button",
              class: "comm-prefs__back",
              disabled: saving.value,
              onClick: handleBack
            }, _toDisplayString(_unref(t)('profile.communicationPreferences.back')), 9, _hoisted_31),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(Button, {
                id: "comm-prefs-save",
                class: "comm-prefs__save",
                classes: ['button-primary', 'bg-primary-blue', 'comm-prefs__save-btn'],
                disabled: saving.value,
                loading: saving.value,
                onButtonClick: handleSave
              }, {
                text: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('profile.communicationPreferences.save')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ])
          ])
        ], 64))
  ]))
}
}

})